import { useState } from 'react';
import { estimateFare } from '../utils/pricing';

export default function BookingForm() {
  const [form, setForm] = useState({
    name: '', phone: '', email: '',
    date: '', time: '', pickup: '', dropoff: '',
    mobility: 'Wheelchair', assistance: 'Driver assist',
    roundTrip: false, notes: ''
  });
  const [errors, setErrors] = useState({});
  const [estimate, setEstimate] = useState(null);

  function onChange(e) {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  }

  function validate() {
    const e = {};
    if (!form.name.trim()) e.name = "Passenger name is required.";
    if (!/[\d+().\-\s]{7,}/.test(form.phone)) e.phone = "Enter a valid phone number.";
    if (!form.date) e.date = "Select a date.";
    if (!form.time) e.time = "Select a time.";
    if (!form.pickup.trim()) e.pickup = "Pickup address is required.";
    if (!form.dropoff.trim()) e.dropoff = "Drop-off address is required.";
    setErrors(e);
    return Object.keys(e).length === 0;
  }

  function handleEstimate() {
    const miles = Math.max(2, Math.round((form.pickup.length + form.dropoff.length) / 20)); // placeholder
    setEstimate({ miles, amount: estimateFare({ miles, mobility: form.mobility, roundTrip: form.roundTrip }) });
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) return;
    alert(`Thanks, ${form.name}! Your request was received. We’ll contact you at ${form.phone}.`);
  }

  return (
    <form className="row g-3" onSubmit={handleSubmit}>
      <div className="col-md-6">
        <label className="form-label">Passenger Name</label>
        <input className={`form-control ${errors.name ? 'is-invalid' : ''}`} name="name" value={form.name} onChange={onChange}/>
        {errors.name && <div className="invalid-feedback">{errors.name}</div>}
      </div>
      <div className="col-md-6">
        <label className="form-label">Phone</label>
        <input className={`form-control ${errors.phone ? 'is-invalid' : ''}`} name="phone" value={form.phone} onChange={onChange}/>
        {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
      </div>

      <div className="col-md-4">
        <label className="form-label">Date</label>
        <input type="date" className={`form-control ${errors.date ? 'is-invalid' : ''}`} name="date" value={form.date} onChange={onChange}/>
        {errors.date && <div className="invalid-feedback">{errors.date}</div>}
      </div>
      <div className="col-md-4">
        <label className="form-label">Time</label>
        <input type="time" className={`form-control ${errors.time ? 'is-invalid' : ''}`} name="time" value={form.time} onChange={onChange}/>
        {errors.time && <div className="invalid-feedback">{errors.time}</div>}
      </div>
      <div className="col-md-4">
        <label className="form-label">Mobility</label>
        <select className="form-select" name="mobility" value={form.mobility} onChange={onChange}>
          <option>Ambulatory</option>
          <option>Wheelchair</option>
          <option>Stretcher</option>
        </select>
      </div>

      <div className="col-12">
        <label className="form-label">Pickup Address</label>
        <input className={`form-control ${errors.pickup ? 'is-invalid' : ''}`} name="pickup" value={form.pickup} onChange={onChange}/>
        {errors.pickup && <div className="invalid-feedback">{errors.pickup}</div>}
      </div>
      <div className="col-12">
        <label className="form-label">Drop-off Address</label>
        <input className={`form-control ${errors.dropoff ? 'is-invalid' : ''}`} name="dropoff" value={form.dropoff} onChange={onChange}/>
        {errors.dropoff && <div className="invalid-feedback">{errors.dropoff}</div>}
      </div>

      <div className="col-md-6">
        <label className="form-label">Assistance Level</label>
        <select className="form-select" name="assistance" value={form.assistance} onChange={onChange}>
          <option>Driver assist</option>
          <option>Door-to-door</option>
          <option>Door-through-door</option>
        </select>
      </div>
      <div className="col-md-6 d-flex align-items-end">
        <div className="form-check">
          <input className="form-check-input" type="checkbox" id="roundTrip" name="roundTrip" checked={form.roundTrip} onChange={onChange}/>
          <label className="form-check-label" htmlFor="roundTrip">Round trip</label>
        </div>
      </div>

      <div className="col-12">
        <label className="form-label">Notes (optional)</label>
        <textarea className="form-control" rows="3" name="notes" value={form.notes} onChange={onChange} placeholder="Gate code, oxygen, caregiver name, etc."/>
      </div>

      <div className="col-12 d-flex gap-2">
        <button type="submit" className="btn btn-primary">Submit Request</button>
        <button type="button" className="btn btn-dark" onClick={handleEstimate}>Get Instant Estimate</button>
        <a className="btn btn-outline-secondary" href="tel:+15551234567">Call</a>
      </div>

      {estimate && (
        <div className="col-12">
          <div className="alert alert-info mt-2">
            Estimated fare: <strong>${estimate.amount}</strong> for ~{estimate.miles} miles ({form.roundTrip ? "round trip" : "one way"}).<br/>
            <span className="text-muted">Final price depends on exact mileage, wait time, and assistance level.</span>
          </div>
        </div>
      )}
    </form>
  );
}
